import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SidebarModule } from "../sidebar/sidebar.module";
import { NavbarModule } from "../navbar/navbar.module";
import { FooterModule } from "../footer/footer.module";
import { AdminLayoutComponent } from "./admin-layout.component";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [
    CommonModule,
    SidebarModule,
    NavbarModule,
    FooterModule,
    RouterModule,
  ],
  declarations: [AdminLayoutComponent],
  exports: [AdminLayoutComponent],
})
export class AdminLayoutModule {}
